import {Spanish} from 'flatpickr/dist/l10n/es.js';
export default {

    // API_BASE_URL: 'https://api.webshift.software',
    // API_BASE_URL: 'https://api.brunodiaz.com.mx',
    // // API_BASE_URL: 'https://api.webshift.software',
    // API_BASE_URL: 'https://api.portatilrecords.com',
    // API_BASE_URL: 'https://api.khairei.app',

    // API_BASE_URL: 'http://localhost:5000',
    // API_BASE_URL: 'https://monitoreofgra.com/api',
    // API_BASE_URL: 'https://api.itzkowich.webshift.software/',
    // API_BASE_URL: 'https://api.nuevo.sroi.webshift.software/',
    // API_BASE_URL: 'https://api.ada.webshift.software/',


    STORAGE_KEY: 'krypton-cadmium',

    flatPickr: {
        // wrap: true,
        locale: Spanish,
        altInput: true,
        dateFormat: 'Y-m-d',
        altFormat: 'l j \\de F, Y',
        ariaDateFormat: 'l j \\de F, Y',
        disableMobile: 'true',
        // minDate: 'today',
    },

    flatTimr: {
        minuteIncrement: 10,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        disableMobile: 'true',
        time_24hr: true
    },

    progressbar: {
        color: '#5867dd',
        failedColor: '#ff0000',
        thickness: '3px',
        autoRevert: true,
        autoFinish: false,
    },

    sweetalert2: {
        showCloseButton: true,
        backdrop: 'rgba(0, 0, 0, 0.15)',
        allowOutsideClick: false,
        showClass: {
            popup: 'scale-in-ver-center'
        },
        hideClass: {
            popup: 'scale-out-vertical'
        }
    },

    sweetToast: {
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        showClass: {
            popup: 'swing-in-top-fwd'
        },
        hideClass: {
            popup: 'swing-out-top-bck'
        }
    },

    slider: {
        dotSize: 14,
        width: 'auto',
        height: 8,
        contained: false,
        direction: 'ltr',
        data: null,
        min: 0,
        max: 100,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: 'active',
        tooltipPlacement: 'top',
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
    },

    proyectos : {

        ada: {
            production: {
                API_BASE_URL: 'https://api.ada.webshift.software/',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },
        webshift: {
            production: {
                API_BASE_URL: 'https://api.webshift.software',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },
        mate: {
            production: {
                API_BASE_URL: 'https://seguimientofgra.com/api',
            },
            development: {
                API_BASE_URL: 'https://seguimientofgra.com/api',
            },
        },
        itzkowich: {
            production: {
                API_BASE_URL: 'https://api.itzkowich.webshift.software/',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },
        sroi: {
            production: {
                API_BASE_URL: 'https://api.nuevo.sroi.webshift.software/',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },
        radio: {
            production: {
                API_BASE_URL: 'https://api.portatilrecords.com',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },
        inversion: {
            production: {
                API_BASE_URL: 'https://api.brunodiaz.com.mx',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },
        khairei: {
            production: {
                API_BASE_URL: 'https://api.khairei.app',
            },
            development: {
                API_BASE_URL: 'http://localhost:5000',
            },
        },

    }

}
